import { Card, CardContent, InfoField, Typography } from '@occc-app/design-system';
import { getActiveSubBrandName } from '@occc-app/routes/Member/MemberDetailsPage/components/SubBrands/sub-brands.utils';
import { SubBrand } from '@occc/feat-constraints';

type SubBrandsProps = {
  activeSubBrandUuid: string | null;
  subBrandList: SubBrand[];
};

export const SubBrands = ({ activeSubBrandUuid, subBrandList }: SubBrandsProps) => {
  const activeSubBrandName =
    activeSubBrandUuid &&
    getActiveSubBrandName({
      activeSubBrandUuid,
      subBrandList,
    });

  return (
    <Card sx={{ mb: 0 }}>
      <CardContent>
        <Typography variant='h6' component='h3' paragraph>
          Subbrands
        </Typography>
        <InfoField
          label='Member’s Active Subbrand'
          value={activeSubBrandName}
          sx={{ overflowWrap: 'anywhere', mb: 0 }}
        />
      </CardContent>
    </Card>
  );
};
